__turbopack_context__.v({
  "paragraph": "u3IQHa_paragraph",
});
